export default "__VITE_PUBLIC_ASSET__144bb9f1__"